<template>
  <div class="coach-separated">
    <div v-if="sharing" class="inline-page" />
    <weui-msg type="warn" :desc="`您的教练(手机：${phone})，暂时还没有打通会员端，现在立刻邀请他开通吧`">
      <weui-button type="primary" @click="invite">邀请教练打通会员端</weui-button>
      <weui-button type="default" @click="goback">再次搜索</weui-button>
    </weui-msg>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import config from '@/config';
import { WeuiMsg, WeuiButton } from '@/components/weui';

const { mapState } = createNamespacedHelpers('wechat');

export default {
    data() {
        return {
            phone: '',
            sharing: false,
        };
    },
    computed: {
        ...mapState({
            wechat_user: state => state.wechat_user || {},
        }),
    },
    created() {
        const { phone } = this.$route.params;
        this.phone = phone;
    },
    methods: {
        invite() {
            this.sharing = true;
            this.$wechat.shareAppMessage({
                title: '邀请加入私教约课系统',
                desc: `您的会员，微信昵称“${this.wechat_user.nickname}”，邀请您使用便捷的私教约课系统“身材觉醒”`,
                link: `${config.uri.coach}/guide/${this.wechat_user.openid}`,
                imageUrl: this.wechat_user.avatar,
            });
        },
        goback() {
            this.$router.go(-1);
        },
    },
    components: {
        WeuiMsg,
        WeuiButton,
    },
};
</script>

<style lang="scss" scoped>
.inline-page {
  background: rgba(0, 0, 0, 0.85) url(../../assets/images/share-invite.png) no-repeat;
  background-size: contain;
  z-index: 1010;
}
</style>




// WEBPACK FOOTER //
// src/containers/trainer_apply/CoachNotVisited.vue